import React from 'react';
import { BaseConfig } from '../BaseConfig';

import "./progress-bar2.css"
import { getGlobalTextSizeStyle, TextHtmlTagType } from '../../misc/tools';

const ProgressBar2 = (props: ProgressBar2Config) => {
	return (
		<div className="modal-disable-select progress-bar2-container" style={{
		}}>
			<div className={'progress-bar2-bar center-element-horizontal ' + ((props.percentage * 100) >= 40 ? 'text-white' : '')}>
				<div className='progress-bar2-bar-inner' style={{
					width: (props.percentage * 100) + '%'
				}}></div>
				<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='default-text center-element white-text'>{Math.round(props.percentage * 100) + '%'}</p>
			</div>
		</div>
	);

};

export interface ProgressBar2Config extends BaseConfig {
	percentage: number;
}

export default ProgressBar2;